import React from 'react';
import { IItemCustomer } from 'types';
import { useTranslation } from 'react-i18next';
import RestaurantsScrollableList from 'components/Lists/ListView/RestaurantsScrollableList';
import Text from 'components/Text/Text';
import style from './MainInfoView.module.scss';

interface IMainInfoView {
	data: IItemCustomer;
}

const MainInfoView: React.FC<IMainInfoView> = ({ data }) => {
	const { t: tForm } = useTranslation('form');
	const defaultLanguage = data.defaultLanguageName ? tForm(data.defaultLanguageName || '') : '-';
	const languages = data.languages.length ? data.languages.map((el) => tForm(el.languageName || '')).join(', ') : '-';

	const restaurants = data.restaurants.map((el) => ({
		...el,
		restaurantName: el.name,
	}));

	return (
		<div className={style.infoContainer} data-test="MainInfoView">
			<div className={style.block}>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="nameLabel"
					theme="neutralLight"
				/>
				<Text className={style.blockValue} translationKey={data.name} withTooltip={true} isNewTooltip={true} />
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="emailLabel"
					theme="neutralLight"
				/>
				<Text className={style.blockValue} translationKey={data.email} withTooltip={true} isNewTooltip={true} />
			</div>
			<div className={style.block}>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="defaultLanguageLabel"
					theme="neutralLight"
				/>
				<Text
					className={style.blockValue}
					translationKey={defaultLanguage}
					withTooltip={true}
					isNewTooltip={true}
				/>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="languagesLabel"
					theme="neutralLight"
				/>
				<Text className={style.blockValue} translationKey={languages} withTooltip={true} isNewTooltip={true} />
			</div>
			<div className={style.block}>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="restaurantsLabel"
					theme="neutralLight"
				/>
				<div className={style.blockValue}>
					<RestaurantsScrollableList restaurants={restaurants} isNewTooltip={true} />
				</div>
			</div>
		</div>
	);
};

export default MainInfoView;
